import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, CardBody, Modal } from 'react-bootstrap';
import { CastType, IQuery, IWhere, IQuerySelectData, DamagedReturnRow, IUploadFilePreviewItem, IQueryTableData } from '../solution/Interfaces';
import { useAuth } from '../../contexts/AuthContext';
import { formatDateFull } from '../solution/utils/AppUtil';
import { Check, FileText, Pencil, Printer, Save, ScanLine, X } from 'lucide-react';
import ShowErrorAlert from '../ShowErrorAlert';
import Logo from "../../assets/img/logo.png";
import bkLogo from "../../assets/img/birkenstock_logo.png";
import hdLogo from "../../assets/img/hey_dude.png";
import tbLogo from "../../assets/img/ted_baker.png";
import dcLogo from "../../assets/img/digicape_logo_black.png";
import htLogo from "../../assets/img/hi-tec.svg"; 
import crLogo from "../../assets/img/crocs_logo_new.png";
import okLogo from "../../assets/img/oakley_logo.jpeg";

interface IStore {
    id: string;
    code: string;
    name: string;
    email: string
    customer_code: string;
    costing_code: string;
    sit_location: string;
    shopify_location_id: string;
    created: string;
    updated: string| null;
}

interface Props {
    store: IStore;
    onBack: () => void;
}

interface IInternalIBT {
     id: string;
     created: string;
     created_by: string;
     updated: string | null;
     doc_num: string,
     category: string,
     internal: boolean;
     from_whs: string;
     notes: string | null;
     status: string;
     to_whs: string;
     returned?: boolean; 
     return_whs?: string | null;
}

interface IInternalIBTLine {
    id: string;
    created: string;
    updated: string | null;
    line_num: number;
    item_name: string;
    item_code: string;
    item_barcode: string;
    doc_num: string;
    qty_scanned_out: number | null;
    qty_on_hand: number | null;
}

interface ISelectedScannedItem {
  id: string;
  barcode: string;
  item_code: string;
  item_group: string;
  name: string;
  product_code: string;
}

  
export const InternalIBT: React.FC<Props> = ({ store, onBack }) => {

  const { fetchData, responseErrorMessage, showErrorAlert, responseStatus }  = useAuth();
  const queryUrl: string = `${process.env.REACT_APP_BASE_URL}/${"query/data"}`;

  const queryUrlTable: string = `${process.env.REACT_APP_BASE_URL}/${"query/table/data"}`;

  const queryUrlSelectNoCount: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data"}`;
  const fetchInternalIBTActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/INTERBRANCH-TRANSFER-ACTIONS/run`; 
  const fetchInternalIBTLineActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/INTERBRANCH-TRANSFER-LINE-ACTIONS/run`; 
  const fetchDamagedReturnQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/STORE-DAMAGES-ACTIONS/run`; 
  const fetchStockTakeFilePreviewQuertUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/SCAN-FILE-SUMMARY/run`; 

  const [internalIBTState, setInternalIBTState] = useState<IInternalIBT[]>([]);
  const [internalIBTLineState, setinternalIBTLineState] = useState<IInternalIBTLine[]>([]);
  const [selectedInternalIBT, setSelectedInternalIBT] = useState<IInternalIBT | null>(null);
  const [selectedInternalIBTValid, setSelectedInternalIBTValid] = useState<IInternalIBT | null>(null);
  const [selectedDocNum, setSelectedDocNum] = useState<string>("");
  const [totalQtyScannedOut, setTotalQtyScannedOut] = useState<number>(0);

  const [submitRefreshData, setSubmitRefreshData] = useState<boolean>(false); 
  const [submitRefreshLineData, setSubmitRefreshLineData] = useState<boolean>(false);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [internalIBTNotes, setInternalIBTNotes] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const [viewMode, setViewMode] = useState<'scan' | 'view' | 'print' | 'default'>('default'); 

  const [loading, setLoading] = useState<boolean>(false);
  const [lineDataCheckLoading, setLineDataCheckLoading] = useState<boolean>(false);
  
  const [showCreateInternalIBTModal, setShowCreateInternalIBTModal] = useState<boolean>(false);
  const [showToSendSInternalIBTModal, setShowToSendSInternalIBTModal] = useState<boolean>(false);
  const [showDeleteInternalIBTModal, setShowDeleteInternalIBTModal] = useState<boolean>(false);
  const [showCreateDamagedReturnModal, setShowCreateDamagedReturnModal] = useState<boolean>(false);

  //refs 
  const fileRef = useRef<HTMLInputElement | null>(null);
  const scanRef = useRef<HTMLInputElement | null>(null);
  const categoryRef = useRef<HTMLSelectElement | null>(null);

  const [selectedScannedItem, setSelectedScannedItem] = useState<ISelectedScannedItem | null>(null);  
  const [showCustomQuantitySection, setShowCustomQuantitySection] = useState<boolean>(false);
  const [customQuantity, setCustomQuantity] = useState<string>('1');

  const [printTarget, setPrintTarget] = useState<'label' | 'manifest'>('label'); 

  const [editingRowId, setEditingRowId] = useState<string | null>(null);
  const [editedQty, setEditedQty] = useState<Record<string, number>>({}); 
  const [inputDraft, setInputDraft] = useState<Record<string, string>>({});

  const [damagedReturnData, setDamagedReturnData] = useState<DamagedReturnRow[]>([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [previewFileUpload, setPreviewFileUpload] = useState<boolean>(false);
  const [previewUploadedFileData, setPreviewUploadedFileData] = useState<IUploadFilePreviewItem[]>([]);
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [previewFailed, setPreviewFailed] = useState<boolean>(false);

  const [shouldResetAfterClose, setShouldResetAfterClose] = useState(false);

  const interbranchTransferQuery = {
    tableName: "sa_ares_interbranch_transfer", 
    where: 'from_whs = :from_whs AND internal = :internal',
    params: { 'from_whs': `${store?.code}`, 'internal': true }
  }; 

  const [queryState, setQueryState] = useState<IQueryTableData>(interbranchTransferQuery); 


  //Query Line State
  const [queryLineState, setQueryLineState] = useState<IQuery>({
    tableName: "sa_ares_interbranch_transfer_line",
    select: [],
    groupBy: [],
    join: [{
      relationship: 'item',
      joinType: "LEFT"
    }],
    orderBy: [ 
        {
            fullColumnName: "created",
            direction: "ASC",
            cast: CastType.TIMESTAMP
        }
    ],
    where:[],
    mainTableOnly: false,
    includeExtraColumns: true,
    includeControlColumns: true,
    modifiedAfter: null,
    touchedBefore: null,
    isDirty: null,
    // pageNum: 0,
    // pageSize: 100,
    frontEndOnly: null
  });

  const defaultQueryState: IQuerySelectData = {
      appCode: "ares",
      selectCode: "scan-item",  
      params: {}
    };   
  
  const [querySelectState, setQuerySelectState] = useState<IQuerySelectData>(defaultQueryState);


  useEffect(() => {
      setLoading(true); 
      fetchData(queryUrlTable, {method:"POST", body: JSON.stringify(queryState)}, processData, cleanUpLoader);
  }, [queryState, submitRefreshData]);


  useEffect(() => {
    if (showCreateInternalIBTModal && categoryRef.current) {
        categoryRef.current.focus();
    }
  }, [showCreateInternalIBTModal]);

  useEffect(() => {
    if (viewMode === "scan" && scanRef.current) {
        scanRef.current.focus();
    }
  }, [viewMode]);

  useEffect(() => {
    if(selectedInternalIBT){
      const queryLine = {...queryLineState}
      queryLine.where = [
            {
              fullColumnName: "doc_num",
              value: selectedInternalIBT?.doc_num, 
              operator: "EQ",
              cast: CastType.STRING
          }       
      ]
      setLoading(true); 
      fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryLine)}, processLineData, cleanUpLoader);
    }
  }, [selectedInternalIBT, submitRefreshLineData]);


   useEffect(() => {
    if(selectedInternalIBTValid){
       const queryLine = {...queryLineState}
      queryLine.where = [
            {
              fullColumnName: "doc_num",
              value: selectedInternalIBTValid?.doc_num, 
              operator: "EQ",
              cast: CastType.STRING
          }       
      ]
      setLoading(true); 
      fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryLine)}, processLineData, cleanUpLoader);
    }
  }, [selectedInternalIBTValid]);

  useEffect(() => {
      if(previewFileUpload && (responseStatus === "400" || responseStatus === "404")){
          setPreviewUploadedFileData([]);
          setPreviewLoading(false);
          setPreviewFailed(true);
      }
  }, [responseStatus, previewFileUpload])


  const processData = (result: any) => {

    const internalIBT: IInternalIBT[] = [];

    // Flatten the result into internalIBT array
    for (const key in result?.data) {
      internalIBT.push({
        ...result.data[key].data,
        ...result.data[key].control,
        ...result.data[key].undefined,
      });
    }

    // Sort by created date descending
    internalIBT.sort(
      (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
    );

    setInternalIBTState(internalIBT);

    // Filter and map only "Damaged" category with "CLOSED" status
    const filtered: DamagedReturnRow[] = internalIBT
      .filter(
        (item: any) =>
          item.category === "Damaged" && item.status === "CLOSED" && item.returned === false
      )
      .map((item: any) => ({
        doc_num: item.doc_num,
        category: item.category,
        from_whs: item.from_whs,
        comments: item.notes ?? null, 
      }));

    setDamagedReturnData(filtered); // Set the filtered data
  };

  const processLineData = (result: any) => {

    const internalIBTLines: IInternalIBTLine[] = [];
    let total = 0;

    for(const key in result?.data){
      // stockReturnLines.push({...result.data[key].data, ...result.data[key].control, ...result.data[key].undefined});

      const entry = result.data[key];
      const control = entry.control || {};
      const data = entry.data || {};

      const qtyScannedOut = data.qty_scanned_out || 0;

      internalIBTLines.push({
          id: control.id,
          created: control.created,
          updated: control.updated ?? null,
          line_num: data.line_num,
          item_name: data["item.name"],
          item_code: data.item_code,
          item_barcode: data["item.barcode"], 
          doc_num: data.doc_num,
          qty_scanned_out: data.qty_scanned_out,
          qty_on_hand: data.qty_on_hand
        });

        total += qtyScannedOut;
  }
  
  setinternalIBTLineState(internalIBTLines);
  setTotalQtyScannedOut(total); 
  };


//default clean up loader
const cleanUpLoader = () => {
    setLoading(false);
    setLineDataCheckLoading(false);
}


// Handle file/folder selection
const handleFolderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const file = event.target.files?.[0];

  if (file) {
    const isXlsx = file.name.toLowerCase().endsWith(".xlsx");

    if (isXlsx) {
      setSelectedFile(file); 
    } else {
      setSelectedFile(null); 
    }
  } else {
    setSelectedFile(null); 
  }
};

// Handle Create Internal IBT
const handleCreateInternalIBTSubmit = () => {
    if (store.code && selectedCategory !== "" && !selectedFile) {
        setLoading(true);
        const combinedCategoryNote = `${selectedCategory} - ${internalIBTNotes || ""}`.trim();
        fetchData(fetchInternalIBTActionsQueryUrl, 
          {method:"POST", body: JSON.stringify({ store_code: store.code, category: selectedCategory, notes: combinedCategoryNote })}, 
          (result: any, status: string) =>  { 
              if(status === "200"){
                  setSelectedInternalIBT(result);
                  setViewMode("scan");
              }
          }, cleanUpLoader);

    }else if (store.code && selectedCategory !== "" && selectedFile) {

        const combinedCategoryNote = `${selectedCategory} - ${internalIBTNotes || ""}`.trim();

        // how to do a multipe part form posts javascript  
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('j1', new Blob([JSON.stringify({ store_code: store.code, category: selectedCategory, notes: combinedCategoryNote })], { type: 'application/json' }));

        const headers = new Headers();
        headers.append("Content-Type", "multipart/formdata");

        setLoading(true);
        fetchData(fetchInternalIBTActionsQueryUrl, 
          {method:"POST", body: formData, headers: headers }, 
          (result: any, status: string) =>  { 
            if(status === "200"){
                setSubmitRefreshData(prev => !prev);
            }
          }, cleanUpLoader);
        
    }else{
        return; // Prevent further execution if the code is not available
    }

    // Reset fileRef after submission
    setSelectedFile(null);
    if (fileRef.current) {
        fileRef.current.value = ''; 
    }

    setInternalIBTNotes("");
    setSelectedCategory("");
    setPreviewFileUpload(false);
    setPreviewUploadedFileData([]);
    setPreviewFailed(false);
 }


  //handle view button when clicked
  const handleViewClick = (internalIBT : IInternalIBT) => {
    setViewMode('view'); // Switch to view mode
    setSelectedInternalIBT(internalIBT);
  }

  //handle scan button when clicked
  const handleScanClick = (internalIBT : IInternalIBT) => {
    setViewMode('scan'); // Switch to Scan mode
    setSelectedInternalIBT(internalIBT);
  }

  //handle print button when clicked
  const handlePrintClick = (internalIBT : IInternalIBT) => {
    setViewMode('print'); // Switch to print mode
    setSelectedInternalIBT(internalIBT);
  }


  // Add the event handler for "Enter" key press
  const handleScanKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, docNum: string) => {
      if (event.key === 'Enter') {
          event.preventDefault();  // Prevent default behavior (if needed)
          handleScanSubmit(docNum); 
      }
  };
   

   const handleScanSubmit = (docNum: string) => {
        setLoading(true);
        const scanValueItemCode = scanRef.current?.value.trim();
        if (!docNum || !scanValueItemCode) return;

        const queryPayload = {
          ...querySelectState,
          params: { ...querySelectState.params, scan_code: scanValueItemCode },
        };

        let shouldRunLineFetch = true;

        fetchData( queryUrlSelectNoCount,
          { method: "POST", body: JSON.stringify(queryPayload)},
          (result: any, status: string) => {
            if (status === "200") {
              const item = result?.data?.[0]?.data;
              const id = result?.data?.[0]?.id;

              if (item && id) {

                const itemGroup = item.item_group;

                const scannedItem: ISelectedScannedItem = {
                  id,
                  barcode: item.barcode,
                  item_code: item.item_code,
                  item_group: itemGroup,
                  name: item.name,
                  product_code: item.product_code,
                };

                setSelectedScannedItem(scannedItem);

                if (itemGroup === "Jibbitz") {
                  setShowCustomQuantitySection(true);
                  shouldRunLineFetch = false; // Don't run line fetch for Jibbitz
                }
              }
            }

            // Only run line fetch if allowed
            if (shouldRunLineFetch) {
             fetchData(fetchInternalIBTLineActionsQueryUrl,
              { method:"POST", body: JSON.stringify({ doc_num: docNum, item_code: scanValueItemCode, qty_scanned_out: 1 })}, 
              (result: any, status: string) =>  { 
                if(status === "200"){
                   setSubmitRefreshLineData(prev => !prev); 
                }
              }, cleanUpLoader);
            } 
            else {
              cleanUpLoader(); // still clean up if skipping line fetch
            }
          }
        );

        if (scanRef.current) {
          scanRef.current.value = "";
        }
    };


    const handleQuantitySubmit = () => {

      if (!selectedScannedItem || !selectedInternalIBT?.doc_num) return;

      const { item_code, barcode } = selectedScannedItem;

      const parsedQty = Math.max(1, parseInt(customQuantity) || 1);

      const payload = {
        doc_num: selectedInternalIBT.doc_num,
        qty_scanned_out: parsedQty,
        item_code: item_code || barcode,
      };

      setLoading(true);

      fetchData(fetchInternalIBTLineActionsQueryUrl,
          { method:"POST", body: JSON.stringify(payload)}, 
          (result: any, status: string) =>  { 
            if(status === "200"){
                 setShowCustomQuantitySection(false);
                 setSelectedScannedItem(null);
                 setCustomQuantity('1');
                 setSubmitRefreshLineData(prev => !prev); 
            }
          }, cleanUpLoader);
    };


   //handle to send internal ibt button when clicked
   const handleSendInternalIBTClick = (internalIBT : IInternalIBT) => {
      setViewMode('default'); // Switch to default mode
      setShowToSendSInternalIBTModal(true);
      setSelectedDocNum(internalIBT.doc_num);
      setSelectedInternalIBTValid(internalIBT);
      setLineDataCheckLoading(true);
   }

   //handle the submit for setting to send interal ibt
  const handleToSendInternalIBTSubmit = () => {
    const isValid = selectedDocNum !== "" && internalIBTLineState.length > 0;

    if (!isValid) return;

    setLoading(true);

    const resetIBTState = () => { setSelectedDocNum(""); setSelectedInternalIBTValid(null); setinternalIBTLineState([]); };

    fetchData(fetchInternalIBTActionsQueryUrl,{ method: "POST", body: JSON.stringify({ doc_num: selectedDocNum, status: "TO_SEND" })},
      (result: any, status: string) => {
        resetIBTState();
        if (status === "200") {
          setSubmitRefreshData(prev => !prev);
        }
      },
      cleanUpLoader
    );
  };


  const handleDeleteInternalIBTClick = (internalIBT : IInternalIBT) => {
      setViewMode('default'); // Switch to default mode
      setShowDeleteInternalIBTModal(true);
      setSelectedDocNum(internalIBT.doc_num);
  }

  const handleDeleteInternalIBTSubmit = () => {
    if(selectedDocNum !== ""){
          setLoading(true);
          fetchData(fetchInternalIBTActionsQueryUrl, 
            {method:"POST", body: JSON.stringify({ doc_num: selectedDocNum,  status: "DELETED" })}, 
            (result: any, status: string) =>  {
                if(status === "200"){
                   // Causes refresh on data  
                   setSubmitRefreshData(prev => !prev);
                }
            }, cleanUpLoader);
            setSelectedDocNum("");
       }else{
         return; 
       }
  }

  const handleEditClick = (id: string, initialQty: number) => {
      setEditingRowId(id);
      setEditedQty(prev => ({ ...prev, [id]: initialQty }));
      setInputDraft(prev => ({ ...prev, [id]: initialQty.toString() }));
  };

  const handleQtyDraftChange = (id: string, value: string) => {
      setInputDraft(prev => ({ ...prev, [id]: value }));
  };

  const handleBlur = (id: string) => {
      const draftValue = inputDraft[id];
      const parsed = parseInt(draftValue, 10);
      setEditedQty(prev => ({ ...prev, [id]: isNaN(parsed) ? 0 : parsed }));
  };

  const handleSaveClick = (id: string) => {
    const qty = editedQty[id];
    const item_code = internalIBTLineState.find(line => line.id === id)?.item_code;
    const doc_num = selectedInternalIBT?.doc_num;

    if (!item_code || qty === undefined || doc_num === undefined) return;

    const payload = {
      doc_num,
      item_code,
      qty_scanned_out: qty,
      mode: 'exact'
    };


    // Perform your save operation here (e.g., API call)
    fetchData(fetchInternalIBTLineActionsQueryUrl,
      { method:"POST", body: JSON.stringify(payload)}, 
      (result: any, status: string) =>  { 
        if(status === "200"){
            setSubmitRefreshLineData(prev => !prev); 
            setEditingRowId(null); // exit edit mode
            setEditedQty({});
            setInputDraft({});
        }
      }, cleanUpLoader);

  };


  //Handling the file preview
  const handleFilePreview = () => {
      if(selectedFile && selectedCategory !== ""){

        setPreviewFileUpload(true);
        setPreviewLoading(true);

        // how to do a multipe part form posts javascript  
        const formData = new FormData();
        formData.append('file', selectedFile);

        const headers = new Headers();
        headers.append("Content-Type", "multipart/formdata");

        fetchData(fetchStockTakeFilePreviewQuertUrl, 
        { method:"POST", body: formData, headers: headers }, 
        ((result: any, status: string) =>  { 
          if(status === "200"){
              setPreviewLoading(false);
              setPreviewUploadedFileData(result || []);
              setPreviewFailed(false);
          }else{
              setPreviewUploadedFileData([]);
              setPreviewLoading(false);
              setPreviewFailed(true);
           }
        })); 

      }else{
        return;
      }
  }

  //handling the file preview cancel reset 
  const handleCancelFilePreview = () => {
      setPreviewFileUpload(false);
      setPreviewUploadedFileData([]);
      setSelectedCategory("");
      setInternalIBTNotes("");
      setPreviewFailed(false);

      // Reset fileRef after submission
      setSelectedFile(null);
      if (fileRef.current) {
        fileRef.current.value = ''; 
      }
  }


  const DisabledScanBtn = () => {
        return (
            <span className="btn h-100 d-flex align-items-center gap-1" title="Scan"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
              >
              <ScanLine style={{ width: "17px", height: "17px", color: "#6c757d" }} />
            </span>
        ) 
  } 

  const DisabledCheckBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Submit"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <Check style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
  } 

  const DisabledDeleteBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Set To Delete"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
          <X style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
        )
  } 

  const DisabledPrintBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Print"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <Printer style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
  } 

  const DisabledEditQtyBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Edit Quantity"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <Pencil style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
  } 

  const DisabledSaveQtyBtn = () => {
        return (
        <span className="btn h-100 d-flex align-items-center gap-1" title="Save Quantity"
              style={{ border: "1px solid #dee6ed", backgroundColor: "#e6e8eb", color: "#6c757d"}}
          >
         <Save style={{ width: "17px", height: "17px", color: "#6c757d" }} />
        </span>
       )
  } 


  const resetInternalIBTModal = () => {

    setShowCreateInternalIBTModal(false);
    setSelectedCategory("");
    setInternalIBTNotes("");
    setSelectedFile(null);

    setPreviewFileUpload(false);
    setPreviewUploadedFileData([]);
    setPreviewFailed(false);
    
    // Clear the file input manually via ref
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };

   //handles the back to internal ibt.
    const handleBackToInternalIBTS = () => {
        setViewMode('default');
        setSelectedInternalIBT(null);
        setTotalQtyScannedOut(0); 
        setShowCustomQuantitySection(false);
        setSelectedScannedItem(null);
        setCustomQuantity('1');
        setPrintTarget('label');
        setEditingRowId(null); // exit edit mode
        setEditedQty({});
        setInputDraft({});
        setPreviewFileUpload(false);
        setPreviewUploadedFileData([]);
        setPreviewFailed(false);
        fetchData(queryUrlTable, {method:"POST", body: JSON.stringify(queryState)}, processData, cleanUpLoader);
    }

    const handleCloseForm = () => {
      setSelectedScannedItem(null);
      setCustomQuantity('1');
      setShowCustomQuantitySection(false); // If you're using this to toggle visibility
    };


   // let customerLogo = Logo;
  const { src: customerLogo, width: customerLogoWidth } = getCustomerLogo();

  function getCustomerLogo() {
    switch (process.env.REACT_APP_COMPANY) {
      case "ares-bk":
        return { src: bkLogo, width: "150px" };
      case "ares-hd":
        return { src: hdLogo, width: "100px" }; // 80
      case "ares-tb":
        return { src: tbLogo, width: "150px" };
      case "digicape":
        return { src: dcLogo, width: "80px" };
      case "hi-tec":
        return { src: htLogo, width: "80px" };
      case "ares-cr":
        return { src: crLogo, width: "160px" };
      case "ares-ok":
        return { src: okLogo, width: "100px" };
      default:
        return { src: Logo, width: "80px" };
    }
  }

  const M24L_3PL_physicalAddress = process.env.REACT_APP_ARES_M24L_3PL_ADDRESS;
  const M24L_3PL_postalCode = process.env.REACT_APP_ARES_M24L_3PL_POSTAL_CODE;
  const M24L_3PL_cityName = process.env.REACT_APP_ARES_M24L_3PL_CITY;
  const M24L_3PL_countryName = process.env.REACT_APP_ARES_M24L_3PL_COUNTRY;

  const M24L_HQ_physicalAddress = process.env.REACT_APP_ARES_M24L_HQ_ADDRESS;
  const M24L_HQ_postalCode = process.env.REACT_APP_ARES_M24L_HQ_POSTAL_CODE;
  const M24L_HQ_cityName = process.env.REACT_APP_ARES_M24L_HQ_CITY;
  const M24L_HQ_countryName = process.env.REACT_APP_ARES_M24L_HQ_COUNTRY;


  const handlePrint = () => {
       window.print();
  }

  const thStyle = {
    border: '1px solid #deebed',
    color: "#6c757d",
    padding: "8px",
    whiteSpace: "nowrap" as const,
    backgroundColor: "#f8f9fa",
  };

  const tdStyle = {
    borderBottom: "1px solid #dee6ed",
    borderRight: "1px solid #dee6ed",
    padding: "8px",
    whiteSpace: "nowrap" as const,
  };




const handleConfirmDamagedReturn = () => {

  if (store.code && selectedWarehouse !== "" && selectedRows.length !== 0) {
        setLoading(true);
        setShowCreateDamagedReturnModal(false);
        fetchData(fetchDamagedReturnQueryUrl, 
          {method: "POST", body: JSON.stringify({ store_code: store.code, to_whs: selectedWarehouse, documents: selectedRows })}, 
          (result: any, status: string) =>  { 
              if(status === "200"){
                  setSubmitRefreshData(prev => !prev);
                  setSelectedWarehouse("");
                  setSelectedRows([]);
              } else{
                setSelectedWarehouse("");
                setSelectedRows([]);
              }
          }, cleanUpLoader);
  }else{
     return; 
  }

};

const handleCreateDamagedReturnModalClose = () => {
  setShowCreateDamagedReturnModal(false);
  setSelectedWarehouse("");
  setSelectedRows([]);
};





    return (
      <>
      { showErrorAlert && !previewFileUpload && <ShowErrorAlert message={responseErrorMessage} /> } 
       <Card>
        <Card.Header>
            <Card.Title>{`Internal (IBT) [${store.name}]`}</Card.Title>                       
        </Card.Header>
        <CardBody>
           <div className="d-flex gap-1">
                   <button
                        className="btn btn-secondary h-100"
                        onClick={() => {
                            if (viewMode === 'default') {
                                onBack();
                            } else {
                                handleBackToInternalIBTS();
                            }
                          }}
                        >
                        { viewMode === 'default' ? "Back To Stock Transfers (IBT)" : "Back To Internal IBT" }
                    </button>
                    {viewMode === 'default' && (
                      <>
                     <button
                        className="btn btn-secondary h-100"
                        onClick={() => setShowCreateInternalIBTModal(true)}
                        >
                        Create Internal IBT
                    </button>
                    <button
                        className="btn btn-secondary h-100"
                         onClick={() => setShowCreateDamagedReturnModal(true)}
                        >
                        Send Damages
                    </button>
                    </>
                    )}
           </div>
           <br></br>    
            <div>
                  { /* Internal IBT Table Start */ }
                  <div style={{ overflowY: "auto" , marginBottom: "4px", position: "relative", backgroundColor: "#fff", borderBottom: "1px solid #dee6ed" }}>
                  <table className="table table-bordered">
                            <thead>                           
                                <tr>
                                    <th style={thStyle}>Doc Number</th>
                                    <th style={thStyle}>Status</th>
                                    <th style={thStyle}>Created</th>
                                    <th style={thStyle}>Notes</th>
                                    <th style={{...thStyle, width: "100px"}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                               { loading && viewMode === "default" ? (
                                 <>
                                    <tr>
                                        <td colSpan={6} className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        </td>
                                    </tr>
                                 </>
                                 ) : (
                                    <>
                                     {!selectedInternalIBT  && viewMode === "default" && internalIBTState.map((internalIBT: IInternalIBT) => (
                                      <tr key={internalIBT.id}>
                                        <td style={tdStyle}>{internalIBT.doc_num}</td>
                                        <td style={tdStyle}>{internalIBT.status}</td>
                                        <td style={tdStyle}>{formatDateFull(internalIBT.created)}</td>
                                        <td style={tdStyle} title={internalIBT?.notes ?? ""}>
                                            <div style={{ 
                                                whiteSpace: "nowrap", 
                                                overflow: "hidden", 
                                                textOverflow: "ellipsis", 
                                                maxWidth: "150px" 
                                            }}>
                                                {internalIBT.notes}
                                            </div>
                                        </td>
                                        <td style={tdStyle} className="d-flex gap-1">

                                            { internalIBT.status === "OPEN" ? (
                                               <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Scan'
                                                 onClick={() => handleScanClick(internalIBT)}
                                                >
                                                  <ScanLine style={{ width: "17px", height: "17px" }} /> 
                                               </button>
                                            ) : (
                                                <DisabledScanBtn/>
                                            )} 

                                           { internalIBT.status === "OPEN" ? (
                                               <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Submit'
                                                 onClick={() => handleSendInternalIBTClick(internalIBT)}
                                                >
                                                 <Check style={{ width: "17px", height: "17px" }}  /> 
                                               </button>
                                            ) : (
                                                <DisabledCheckBtn/>
                                            )} 


                                            <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='View'
                                               onClick={() => handleViewClick(internalIBT)}
                                            >
                                                <FileText style={{ width: "17px", height: "17px" }}  /> 
                                            </button>

                                            {(internalIBT.status === "OPEN") ? (
                                                 <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Set To Delete'
                                                    onClick={() => handleDeleteInternalIBTClick(internalIBT)}
                                                  >
                                                  <X style={{ width: "17px", height: "17px" }}  /> 
                                                 </button>
                                                ) : (
                                                <DisabledDeleteBtn/>
                                            )}  

                                           
                                            <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='Print'
                                                onClick={() => handlePrintClick(internalIBT)}
                                              >
                                                <Printer style={{ width: "17px", height: "17px" }}  /> 
                                            </button>
                                            
                                        </td>
                                     </tr>
                                   ))}
                                 </>
                                )}

                             
                                {selectedInternalIBT && viewMode !== "default" &&
                                    <>
                                        <tr key={selectedInternalIBT.id}>
                                            <td style={tdStyle}>{selectedInternalIBT.doc_num}</td>
                                            <td style={tdStyle}>{selectedInternalIBT.status}</td>
                                            <td style={tdStyle}>{formatDateFull(selectedInternalIBT.created)}</td>
                                            <td style={tdStyle} title={selectedInternalIBT?.notes ?? ""}>
                                            <div style={{ 
                                                whiteSpace: "nowrap", 
                                                overflow: "hidden", 
                                                textOverflow: "ellipsis", 
                                                maxWidth: "150px" 
                                            }}>
                                                {selectedInternalIBT.notes}
                                            </div>
                                          </td>
                                          <td style={tdStyle}>
  
                                          </td>
                                        </tr>
                                        <tr >
                                            <td  colSpan={9} style={{ textAlign: 'center' }}>
                                                    { viewMode === 'view' || viewMode === 'print' ? (null) : (
                                                    <>
                                                      {selectedScannedItem && showCustomQuantitySection ? (
                                                          <form
                                                            onSubmit={(e) => {
                                                              e.preventDefault();
                                                              handleQuantitySubmit();
                                                            }}
                                                            className="p-3 border rounded bg-light"
                                                            style={{ display: 'inline-block', textAlign: 'left', minWidth: '600px' }}
                                                          >
                                                            <div className="mb-3 position-relative">
                                                              <div className="d-flex justify-content-between align-items-center">
                                                                <h6 className="mb-0" style={{ fontWeight: 600 }}>Scanned Item Details</h6>
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                  style={{ width: '28px', height: '28px' }}
                                                                  onClick={handleCloseForm}
                                                                  aria-label="Close"
                                                                >
                                                                  <X size={16} />
                                                                </button>
                                                              </div>
                                                              <hr className="my-2" />
        
                                                              <div className="row">
                                                                <div className="col-md-6 mb-2">
                                                                  <label className="form-label mb-0"><strong>Name:</strong></label>
                                                                  <div className="form-control-plaintext">{selectedScannedItem.name}</div>
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                  <label className="form-label mb-0"><strong>Item Group:</strong></label>
                                                                  <div className="form-control-plaintext">{selectedScannedItem.item_group}</div>
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                  <label className="form-label mb-0"><strong>Item Code:</strong></label>
                                                                  <div className="form-control-plaintext">{selectedScannedItem.item_code}</div>
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                  <label className="form-label mb-0"><strong>Barcode:</strong></label>
                                                                  <div className="form-control-plaintext">{selectedScannedItem.barcode}</div>
                                                                </div>
                                                              </div>
                                                            </div>
        
                                                            <div className="d-flex align-items-center justify-content-between">
                                                              <div className="d-flex align-items-center">
                                                                <label htmlFor="custom_quantity" className="form-label mb-0 me-2"><strong>Quantity:</strong></label>
                                                                  <input
                                                                    type="number"
                                                                    id="custom_quantity"
                                                                    name="custom_quantity"
                                                                    min={1}
                                                                    value={customQuantity}
                                                                    onChange={(e) => setCustomQuantity(e.target.value)}
                                                                    className="form-control form-control-sm"
                                                                    style={{ width: '100px' }}
                                                                  />
                                                              </div>
        
                                                              <button type="submit" className="btn btn-dark btn-sm ms-3">
                                                                Save Qauntity
                                                              </button>
                                                            </div>
                                                          </form>
                                                      ) : (
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                          <span style={{ marginRight: '10px' }}>Scan</span>
                                                          <input
                                                            ref={scanRef}
                                                            id="scan_code"
                                                            name="scan_code"
                                                            type="text"
                                                            autoComplete="off"
                                                            className="form-control form-control-md w-25"
                                                            style={{ margin: 0 }}
                                                            onKeyDown={(e) => handleScanKeyDown(e, selectedInternalIBT.doc_num)}
                                                          />
                                                        </div>
                                                      )}
                                                    </>
                                                  )}
                                            </td>
                                        </tr>
                                    </>
                                }       
                            </tbody>
                     </table>
                   </div>
                  { /* Internal IBT Table  End */ }

                  {internalIBTLineState && viewMode !== "default" && viewMode !== "print" &&
                   <div style={{ overflowY: "auto" , marginBottom: "4px", position: "relative", backgroundColor: "#fff", borderBottom: "1px solid #dee6ed" }}>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th style={thStyle}>Line No.</th>
                            <th style={thStyle}>Item Name</th>
                            <th style={thStyle}>Item Code</th>
                            <th style={thStyle}>Item Barcode</th>
                            {selectedInternalIBT?.status !== "OPEN" && <th style={{...thStyle, width: '112px'}}>QTY On Hand</th>}
                            <th style={{...thStyle, width: '138px'}}>QTY Scanned Out</th>
                            {selectedInternalIBT?.status === "OPEN" && <th style={{...thStyle, width: "100px"}}>Actions</th>}
                          </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={6} className="text-center">
                              <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          internalIBTLineState.map((internalIBTLine: IInternalIBTLine) => {
                            const isEditing = editingRowId === internalIBTLine.id;
                            return (
                              <tr key={internalIBTLine.id}>
                                <td style={tdStyle}>{internalIBTLine.line_num}</td>
                                <td style={tdStyle}>{internalIBTLine.item_name}</td>
                                <td style={tdStyle}>{internalIBTLine.item_code}</td>
                                <td style={tdStyle}>{internalIBTLine.item_barcode}</td>
                                {selectedInternalIBT?.status !== "OPEN" && <td className="text-end">{internalIBTLine.qty_on_hand}</td>}
                                <td style={tdStyle} className="text-end">
                                  {isEditing ? (
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        style={{ maxWidth: "80px", fontSize: "0.85rem", padding: "0.25rem"}}
                                        value={inputDraft[internalIBTLine.id] ?? ''}
                                        onChange={(e) => handleQtyDraftChange(internalIBTLine.id, e.target.value)}
                                        onBlur={() => handleBlur(internalIBTLine.id)}
                                        autoFocus
                                        onClick={(e) => (e.target as HTMLInputElement).select()}
                                        onFocus={(e) => (e.target as HTMLInputElement).select()}
                                        />
                                      </div>
                                    ) : (
                                        internalIBTLine.qty_scanned_out
                                    )}
                                </td>
                                  {selectedInternalIBT?.status === "OPEN" && (
                                  <td style={tdStyle} className='d-flex gap-1'>
                                       {isEditing ? (
                                        <>
                                          { !inputDraft[internalIBTLine.id]?.trim() ? (
                                             <DisabledSaveQtyBtn/>
                                            ) : (
                                              <button
                                                className="btn btn-secondary h-100 d-flex align-items-center gap-1"
                                                onClick={() => handleSaveClick(internalIBTLine.id)}
                                                title="Save Quantity"
                                                >
                                                <Save style={{ width: "17px", height: "17px" }} />
                                              </button>
                                            )
                                          }
                                         
                                          <button
                                            className="btn btn-secondary h-100 d-flex align-items-center gap-1"
                                            onClick={() => setEditingRowId(null)}
                                            title="Cancel"
                                          >
                                            <X style={{ width: "17px", height: "17px" }} />
                                          </button>
                                        </>
                                      ) : editingRowId === null ? (
                                        <button
                                          className="btn btn-secondary h-100 d-flex align-items-center gap-1"
                                          onClick={() =>
                                            handleEditClick(
                                              internalIBTLine.id,
                                              internalIBTLine.qty_scanned_out ?? 0
                                            )
                                          }
                                          title="Edit Quantity"
                                        >
                                          <Pencil style={{ width: "17px", height: "17px" }} />
                                        </button>
                                      ) : (<DisabledEditQtyBtn/>) }

                                  </td>
                                )}
                              </tr>
                            );
                          })
                        )}
                        </tbody>
                      </table>
                    </div>
                    }
                     

                    {selectedInternalIBT && viewMode === 'print' && 
                       <div>
                          <h5 className="mt-4 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1 d-flex justify-content-between align-items-center">
                            <span>Select Print Option:</span>
                          </h5>
                          <div className='d-flex gap-1'>
                            <button onClick={() => setPrintTarget('label')}  className={`btn ${printTarget === 'label' ? 'btn-primary' : 'btn-secondary'}`}>Label</button>
                            <button onClick={() => setPrintTarget('manifest')} className={`btn ${printTarget === 'manifest' ? 'btn-primary' : 'btn-secondary'}`}>Manifest</button>
                          </div>
                        </div>
                     }

                     {selectedInternalIBT && viewMode === 'print' && (
                      <>
                        <h5 className="mt-4 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1 d-flex justify-content-between align-items-center">
                          <span>{printTarget === 'label' ? 'Print Label' : 'Print Manifest'}</span>
                          <button
                            className="btn btn-secondary d-flex align-items-center gap-1"
                            title={printTarget === 'label' ? 'Print Label' : 'Print Manifest'}
                            onClick={handlePrint}
                          >
                            <Printer style={{ width: "17px", height: "17px" }} />
                          </button>
                        </h5>

                        <div className="preview-print-container">
                          {printTarget === 'label' && (
                            <div id="print-label" className="print-sticker">
                               {/* Top Row: Logo + Info */}
                                <div className="store-logo-section">
                                  {/* Logo */}
                                  <div className='store-logo'>
                                    <img src={customerLogo} style={{ width: customerLogoWidth }} />
                                  </div>

                                  {/* Info */}
                                  <div className='store-ref-section'>
                                    <p style={{ fontWeight: 'bold', margin: 0, fontSize: "18px" }}>Internal IBT</p>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                      <span style={{ fontWeight: 'bold' }}>Ref:</span>
                                      <span>{selectedInternalIBT.doc_num}</span>
                                    </div>
                                  </div>
                                </div>

                                {/* Warehouse Details */}
                                <div style={{ marginTop: '10px', marginBottom: '10px', width: '100%' }}>
                                  {[
                                    { label: 'From Warehouse:', value: store.name },
                                    { label: 'Reason:', value: selectedInternalIBT.category },
                                    { label: 'Total Items:', value: totalQtyScannedOut },

                                    // Conditionally include destination address if it's a return and to_whs is present
                                    ...(selectedInternalIBT.returned && selectedInternalIBT.return_whs
                                      ? selectedInternalIBT.return_whs === 'HQ'
                                        ? [
                                            { label: 'To Warehouse Address:', value: M24L_HQ_physicalAddress },
                                            { label: 'Postal Code:', value: M24L_HQ_postalCode },
                                            { label: 'City:', value: M24L_HQ_cityName },
                                            { label: 'Country:', value: M24L_HQ_countryName },
                                          ]
                                        : selectedInternalIBT.return_whs === '3PL_DM1'
                                        ? [
                                            { label: 'To Warehouse Address:', value: M24L_3PL_physicalAddress },
                                            { label: 'Postal Code:', value: M24L_3PL_postalCode },
                                            { label: 'City:', value: M24L_3PL_cityName },
                                            { label: 'Country:', value: M24L_3PL_countryName },
                                          ]
                                        : []
                                      : []),
                                  ].map(({ label, value }) => (
                                    <div
                                      key={label}
                                      style={{
                                        display: 'flex',
                                        gap: '4px',
                                        flexWrap: 'wrap',
                                        ...(label === 'To Warehouse Address:' ? { marginTop: '12px' } : {}),
                                      }}
                                    >
                                      <span style={{ fontWeight: 'bold' }}>{label}</span>
                                      <span>{value}</span>
                                    </div>
                                  ))}
                                </div>

                                {/* Notes */}
    
                                <div className="notes-section">
                                  <p style={{ margin: 0 }}>Notes: {selectedInternalIBT.notes}</p>
                                </div>
                            </div>
                          )}

                          {printTarget === 'manifest' && (
                            <div id="print-label" className="print-sticker">
                              {/* Manifest content goes here */}
                               {/* Top Row: Logo + Info */}
                                <div className="store-logo-section">
                                  {/* Logo */}
                                  <div className='store-logo'>
                                    <img src={customerLogo} style={{ width: customerLogoWidth }} />
                                  </div>

                                  {/* Info */}
                                  <div className='store-ref-section'>
                                    <p style={{ fontWeight: 'bold', margin: 0, fontSize: "18px" }}>Internal IBT</p>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                      <span style={{ fontWeight: 'bold' }}>Ref:</span>
                                      <span>{selectedInternalIBT.doc_num}</span>
                                    </div>
                                  </div>
                                </div>

                                {/* Warehouse Details */}
                                <div style={{ marginTop: '10px', marginBottom: '10px', width: '100%' }}>
                                  {[
                                    { label: 'From Warehouse:', value: store.name },
                                    { label: 'Reason:', value: selectedInternalIBT.category },
                                    { label: 'Total Items:', value: totalQtyScannedOut },

                                    // Conditionally include destination address if it's a return and to_whs is present
                                    ...(selectedInternalIBT.returned && selectedInternalIBT.return_whs
                                      ? selectedInternalIBT.return_whs === 'HQ'
                                        ? [
                                            { label: 'To Warehouse Address:', value: M24L_HQ_physicalAddress },
                                            { label: 'Postal Code:', value: M24L_HQ_postalCode },
                                            { label: 'City:', value: M24L_HQ_cityName },
                                            { label: 'Country:', value: M24L_HQ_countryName },
                                          ]
                                        : selectedInternalIBT.return_whs === '3PL_DM1'
                                        ? [
                                            { label: 'To Warehouse Address:', value: M24L_3PL_physicalAddress },
                                            { label: 'Postal Code:', value: M24L_3PL_postalCode },
                                            { label: 'City:', value: M24L_3PL_cityName },
                                            { label: 'Country:', value: M24L_3PL_countryName },
                                          ]
                                        : []
                                      : []),
                                  ].map(({ label, value }) => (
                                    <div
                                      key={label}
                                      style={{
                                        display: 'flex',
                                        gap: '4px',
                                        flexWrap: 'wrap',
                                        ...(label === 'To Warehouse Address:' ? { marginTop: '12px' } : {}),
                                      }}
                                    >
                                      <span style={{ fontWeight: 'bold' }}>{label}</span>
                                      <span>{value}</span>
                                    </div>
                                  ))}
                                </div>


                                {/* Adding the Items: label */}
                               <div style={{ marginTop: '12px', width: '100%' }}>
                                <span style={{ fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Items Manifest:</span>
                                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                                  <thead>
                                    <tr>
                                      <th style={{ textAlign: 'left', padding: '4px', borderBottom: '1px solid #ccc' }}>Code</th>
                                      <th style={{ textAlign: 'left', padding: '4px', borderBottom: '1px solid #ccc' }}>Name</th>
                                      <th style={{ textAlign: 'right', padding: '4px', borderBottom: '1px solid #ccc' }}>Quantity</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {internalIBTLineState.map((internalIBTLine: IInternalIBTLine) => (
                                      <tr key={internalIBTLine.id}>
                                        <td style={{ padding: '4px 8px' }}>{internalIBTLine.item_code}</td>
                                        <td style={{ padding: '4px 8px' }}>{internalIBTLine.item_name}</td>
                                        <td style={{ padding: '4px 8px', textAlign: 'right' }}>{internalIBTLine.qty_scanned_out}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>

                                {/* Notes */}
    
                                <div className="notes-section">
                                  <p style={{ margin: 0 }}>Notes: {selectedInternalIBT.notes}</p>
                                </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    
               </div>                                   
     
        </CardBody>

           {/* Modal Create Internal IBT - Start */}
            <>
              <Modal show={showCreateInternalIBTModal} onHide={resetInternalIBTModal}>
                  <Modal.Header closeButton>
                      <Modal.Title>{`Creating Internal IBT [${store.name}]`}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {showErrorAlert && previewFileUpload && <ShowErrorAlert message={responseErrorMessage} /> } 
                    {previewFileUpload ? (
                       <div style={{ width: '100%' }}>
                          <div className="d-flex justify-content-between align-items-center mt-3 mb-2 border-bottom pb-1">
                            <h5 className="text-uppercase text-secondary fw-bolder mb-0">File Preview</h5>
                            {!previewLoading && previewUploadedFileData.length > 0 && (
                              <div className="fw-bolder text-end text-nowrap" style={{ fontSize: "0.85rem", color: "#333" }}>
                                Total Qty: {previewUploadedFileData.reduce((acc, cur) => acc + (cur.count || 0), 0)}
                              </div>
                            )}
                          </div>
                          <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd" }}>
                            <table className="table table-bordered table-sm">
                              <thead className="table-light">                           
                                  <tr>
                                      <th style={{ color: 'gray' }}>Item Name</th>
                                      <th style={{ color: 'gray' }}>Item Code</th>
                                      <th style={{ color: 'gray' }}>Item Barcode</th>
                                      <th style={{ color: 'gray' }}>Qty</th>
                                  </tr>                                                             
                              </thead>
                              <tbody>
                                {previewLoading ? (
                                  <tr>
                                      <td colSpan={4} className="text-center">
                                          <div className="spinner-border" role="status">
                                              <span className="visually-hidden">Loading...</span>
                                          </div>
                                      </td>
                                  </tr>
                              ) : (
                                   previewUploadedFileData.length > 0 && previewUploadedFileData.map((previewLine: IUploadFilePreviewItem) => {
                                      return (
                                        <tr key={previewLine.barcode}>
                                            <td style={{ maxWidth: "120px" }}>
                                              <span title={previewLine.name ?? ""} style={{ display: "inline-block", maxWidth: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", verticalAlign: "middle"}}>
                                                {previewLine.name}
                                              </span>
                                            </td>
                                            <td>{previewLine.itemCode}</td>
                                            <td>{previewLine.barcode}</td>
                                            <td style={{ textAlign: 'right' }}>{previewLine.count}</td>
                                        </tr>
                                        );
                                    })
                                  )}
                                </tbody>
                              </table>
                            </div>
                        </div>
                    ) : (
                      <>
                      <div className='informational-message-section'>
                          <strong>Note:</strong> You can proceed without uploading a file. Simply click 
                          <strong> Create </strong> to skip this step and scan your items directly in the interface. 
                              The system will guide you through entering or capturing the necessary information on the next screen.
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                      <label htmlFor="file_category" style={{ marginBottom: '6px', fontWeight: 'bold', marginLeft: '4px' }}>
                            Select Interal Store Option:
                            <span style={{ color: '#c0392b', fontWeight: 'normal', marginLeft: '8px' }}>
                                * Required
                            </span>
                        </label>
                        <select
                            ref={categoryRef}
                            id="internal_IBT_category"
                            name="internal_IBT_category"
                            className="form-control form-control-md w-80 mb-2"
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                        >
                            <option value="">-- Select Internal IBT Option --</option>
                            <option value="Damaged">Store Damages</option>
                            <option value="Staff">Staff Uniform</option>
                            <option value="Marketing">Marketing</option>
                        </select>
                        <label htmlFor="file_codes" style={{ marginBottom: '6px', fontWeight: 'bold', marginLeft: '4px' }}>
                            Upload File:
                            <span style={{ color: '#c0392b', fontWeight: 'normal', marginLeft: '8px' }}>
                                * Optional – Only .xlsx files supported
                            </span>
                        </label>
                        <input ref={fileRef} id="file_codes" name="file_codes" type="file" accept=".xlsx" className="form-control form-control-md w-80" onChange={handleFolderChange} />
                        <label htmlFor="file_codes" style={{ marginBottom: '6px', fontWeight: 'bold', marginLeft: '4px', marginTop: '8px' }}>
                              Leave Notes:
                            <span style={{ color: '#c0392b', fontWeight: 'normal', marginLeft: '8px' }}>
                                * Optional 
                            </span>
                        </label>
                        <textarea
                            id="store_return_notes"
                            name="store_return_notes"
                            className="form-control form-control-md w-80"
                            value={internalIBTNotes}
                            onChange={(e) => setInternalIBTNotes(e.target.value)}
                        />
                    </div>
                     </>
                    )}
                 
                  </Modal.Body>
                   <Modal.Footer>
                      {/* Main Action Button */}
                      {selectedFile === null || previewFileUpload ? (
                        <Button variant="primary" disabled={!selectedCategory || (previewFileUpload && previewFailed)}
                          onClick={() => { setShowCreateInternalIBTModal(false); handleCreateInternalIBTSubmit(); }}
                        >
                           { selectedFile ? "Upload" : " Create" } 
                        </Button>
                      ) : (
                        <Button variant="primary" onClick={handleFilePreview}>
                          Preview
                        </Button>
                      )}

                      {/* Cancel Button */}
                      <Button variant="secondary" onClick={previewFileUpload ? handleCancelFilePreview : resetInternalIBTModal}>
                        Cancel
                      </Button>
                    </Modal.Footer>
              </Modal>
            </> 
          {/* Modal Create Store Return - End */}



           {/* Modal To Create Damaged Return - Start */}
            <>
              <Modal show={showCreateDamagedReturnModal} onHide={handleCreateDamagedReturnModalClose}>
                <Modal.Header closeButton>
                  <Modal.Title>{`Create Damaged Return`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                  {/* Warehouse Select */}
                  <div className="mb-3">
                    <label htmlFor="toWarehouse" className="form-label">
                      To Warehouse
                    </label>
                    <select id="toWarehouse" className="form-select" value={selectedWarehouse} onChange={(e) => setSelectedWarehouse(e.target.value)}>
                      <option value="">Select a warehouse</option>
                      <option value="3PL_DM1">3PL_DM1</option>
                      <option value="HQ">HQ</option>
                    </select>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <small className="text-muted">Total Records: {damagedReturnData.length}</small>
                    <small className="text-muted">Selected: {selectedRows.length}</small>
                  </div>

                  {/* Scrollable Table */}
                  <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd" }}>
                    <table className="table table-bordered table-sm">
                      <thead className="table-light">
                         <tr>
                           <th style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '0.45rem', paddingBottom: '0.66rem', }}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={(e) => {
                                const checked = e.target.checked;
                                const allIds = damagedReturnData.map((row) => row.doc_num);
                                setSelectedRows(checked ? allIds : []);
                              }}
                              checked={damagedReturnData.length > 0 && selectedRows.length === damagedReturnData.length}
                              disabled={damagedReturnData.length === 0}
                            />
                          </th>
                          <th style={{ color: 'gray', verticalAlign: 'middle' }}>Doc Num</th>
                          <th style={{ color: 'gray', verticalAlign: 'middle' }}>Category</th>
                          <th style={{ color: 'gray', verticalAlign: 'middle' }}>From Warehouse</th>
                          <th style={{ color: 'gray', verticalAlign: 'middle' }}>Comments</th>
                        </tr>
                      </thead>
                      <tbody>
                         {damagedReturnData.map((row) => (
                          <tr key={row.doc_num}>
                            <td style={{ textAlign: 'center', verticalAlign: 'middle',  paddingBottom: '0.70rem', height:'40px' }}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedRows.includes(row.doc_num)}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  setSelectedRows((prev) =>
                                    isChecked ? [...prev, row.doc_num] : prev.filter((id) => id !== row.doc_num)
                                  );
                                }}
                              />
                            </td>
                            <td style={{ verticalAlign: "middle" }}>{row.doc_num}</td>
                            <td style={{ verticalAlign: "middle" }}>{row.category}</td>
                            <td style={{ verticalAlign: "middle" }}>{row.from_whs}</td>
                            <td style={{ maxWidth: "150px", padding: "0.5rem", verticalAlign: "middle" }}>
                              <span
                                title={row.comments ?? ""}
                                style={{
                                  display: "inline-block",
                                  maxWidth: "100%",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  verticalAlign: "middle",
                                }}
                              >
                                {row.comments}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" onClick={handleConfirmDamagedReturn} disabled={selectedRows.length === 0 || selectedWarehouse === ""}>
                    Create
                  </Button>
                  <Button variant="secondary" onClick={handleCreateDamagedReturnModalClose}>
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>
            </>

          {/* Modal To Create Damaged Return - End */}


           {/* Modal To Send Internal IBT - Start */}
            <>
               <Modal
                show={showToSendSInternalIBTModal}
                onHide={() => {setShowToSendSInternalIBTModal(false); setShouldResetAfterClose(true);}}
                onExited={() => {
                  if (shouldResetAfterClose) {
                    setSelectedDocNum('');
                    setSelectedInternalIBTValid(null);
                    setinternalIBTLineState([]);
                    setShouldResetAfterClose(false);
                  }
                }}
              >
                <Modal.Header closeButton>
                  <Modal.Title>{`Send Internal IBT [${selectedDocNum}]`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                    { lineDataCheckLoading ? (
                        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px" }} >
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p style={{ marginTop: "10px", fontWeight: 600 }}>
                              Transaction Processing... Please wait. 
                            </p>
                        </div>
                      ) : (selectedDocNum === '' || internalIBTLineState.length === 0) ? (
                      <div className="informational-message-section">
                        <strong>Note:</strong> Unable to send the document. At least one line must be saved to it before submission.
                      </div>
                    ) : (
                      <p>Are you sure you would like to send this internal IBT?</p>
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="primary"
                    disabled={selectedDocNum === '' || internalIBTLineState.length === 0}
                    onClick={() => {
                      handleToSendInternalIBTSubmit();
                      setShowToSendSInternalIBTModal(false);
                      setShouldResetAfterClose(true);
                    }}
                  >
                    Confirm
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShowToSendSInternalIBTModal(false);
                      setShouldResetAfterClose(true);
                    }}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>

            </>
          {/* Modal To Send Internal IBT - End */}


           {/* Modal Delete Internal IBT - Start */}
            <>
              <Modal show={showDeleteInternalIBTModal} onHide={() => { setShowDeleteInternalIBTModal(false); }}>
                  <Modal.Header closeButton>
                      <Modal.Title>{`Delete Internal IBT [${selectedDocNum}]`}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                      <p>Are you sure you would like to delete this internal IBT?</p>
                  </div>
                  </Modal.Body>
                  <Modal.Footer>
                  <Button variant="primary" onClick={() => { setShowDeleteInternalIBTModal(false); handleDeleteInternalIBTSubmit();  }}>
                      Confirm
                  </Button>
                  <Button variant="secondary" onClick={() => { setShowDeleteInternalIBTModal(false); } }>
                      Cancel
                  </Button>
                  </Modal.Footer>
              </Modal>
            </> 
          {/* Modal Delete Internal IBT - End */}


      </Card>
    </>
    );
  };